import React from "react";
import { BiNetworkChart } from "react-icons/bi";
import { IoAppsOutline } from "react-icons/io5";
import { LuWorkflow } from "react-icons/lu";
import { MdPeopleOutline, MdTune } from "react-icons/md";
import { PiLightningThin } from "react-icons/pi";
import { RiKey2Line } from "react-icons/ri";
import { TbGalaxy } from "react-icons/tb";
import { TiCloudStorageOutline } from "react-icons/ti";
import { VscOrganization } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import { GoDotFill } from "react-icons/go";


const FirstSection = () => {
    const navigate = useNavigate()

    const items = [
        {
            icon: VscOrganization,
            title: "Companies",
            description: "Create and manage companies, brands, and growth environments."
        },
        {
            icon: IoAppsOutline,
            title: "Products",
            description: "Define the products, services, offers, and markets you want to grow."
        },
        {
            icon: BiNetworkChart,
            title: "Intelligence",
            description: "Build a living model of your company, customers, competitors, and market."
        },
        {
            icon: LuWorkflow,
            title: "Strategies",
            description: "Design and explore growth strategies across channels, markets, and initiatives."
        },
        {
            icon: PiLightningThin,
            title: "Simulations",
            description: "Simulate different growth scenarios to understand outcomes, costs, and trade-offs."
        },
        {
            icon: MdTune,
            title: "Allocation",
            description: "Decide where to invest your budget, people, and resources for maximum growth."
        },
        {
            icon: RiKey2Line,
            title: "Campaigns",
            description: "Launch and manage growth campaigns across paid, organic, AI, and social channels."
        },
        {
            icon: TiCloudStorageOutline,
            title: "Knowledge",
            description: "Connect documents, data, analytics, and business context to Abstracht."
        },
        {
            icon: MdPeopleOutline,
            title: "Agents",
            description: "Deploy specialized AI agents that execute, monitor, and optimize growth activities."
        }
    ];

    const navigateUrlSales = () => {
        navigate("/contact/sales")
    }

    const navigatePricing = () => {
        navigate("/pricing")
    }

    return (
        <div className="firt_section">
            {/* <div className="first_section_sidebar">
                <div className="first_section_sidebar_inner">
                    <p className="first_section_sidebar_link"></p>
                    <p className="first_section_sidebar_link" onClick={navigateUrlSales}><i><GoDotFill /></i> Contact sales</p>
                </div>
            </div> */}
            <div className="firt_section_main">
                <div className="firt_section_main_inner">
                    <h1>Abstracht empowers companies to understand, simulate, and accelerate growth.</h1>
                    <p>
                        Abstracht is an AI-powered growth platform designed to help companies understand
                        their business, discover growth opportunities, simulate strategies, and decide
                        where to invest their resources. It brings company intelligence, market analysis,
                        growth strategy, simulations, budget allocation, and execution into one connected
                        environment. Abstracht continuously analyzes products, customers, competitors,
                        channels, and performance to build a living model of how a business can grow.
                        Companies can explore different strategies, understand their expected impact and
                        trade-offs, allocate budgets and resources, and turn approved strategies into
                        executable campaigns across organic, paid, AI, social, and other growth channels.
                        As results come in, Abstracht measures performance, learns from outcomes, and
                        continuously adapts where resources should be invested. It transforms growth
                        from a collection of disconnected marketing activities into an intelligent,
                        measurable, and continuously optimized system.
                    </p>
                </div>
                <div className="list_wrapper">
                    <div className="list_track">
                        {[...items, ...items].map((item, index) => {
                            const Icon = item.icon;

                            return (
                                <div className="list_item" key={index}>
                                    <p className="list_item_title">
                                        <i className="list_item_icon"><Icon /></i>
                                        {item.title}
                                    </p>
                                    <span className="list_item_desc">
                                        {item.description}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default FirstSection